<!--Have to use display:flex in some places and not d-flex because d-flex has !important, which overrides [hidden]-->
<!-- Back button -->
<div class="row my-2">
    <div class="col-3">
        <button type="button" class="btn btn-text-gray btn-icon ml-n3" (click)="backClick()">
            <svg><use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use></svg>
            <div cvLocalizedText langSection="Common" langKey="Back_Button">Back</div>
        </button>
    </div>
</div>

<!-- New Objective button and search field -->
<div class="row align-items-center">
    <div class="col-3">
        <button type="button" class="btn btn-primary btn-icon" (click)="clickNew()">
            <svg><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
            <span cvLocalizedText langSection="Objectives" langKey="New_Objective">New Objective</span>
        </button>
    </div>

    <div class="col-6"></div>

    <div class="col-3">
        <div class="search-box live-search">
            <input type="search" class="form-control form-control-gray" placeholder="Search Metrics" [(ngModel)]="filterSelectedText" (ngModelChangeDebounced)="applyFilter()" [ngModelChangeDebounceTime]="400"
                   cvLocalizedPlaceholder langSection="Objectives" langKey="Search_Metrics" />
            <span class="clear-input" *ngIf="filterSelectedText.length > 0" (click)="clearSelectedSearch()"></span>
        </div>
    </div>
</div>

<!-- Header -->
<div class="row my-3">
    <div class="col-12 d-flex align-items-center">
        <div class="font-size-24 mr-2" *ngIf="objectiveService.selectedGroupItem != null">{{objectiveService.selectedGroupItem.groupDTO.GroupName + ' - '}}</div>
        <div class="font-size-24" *ngIf="objectiveService.selectedGroupItem != null">{{objectiveService.selectedGroupItem.groupDTO.BaseGroupType == 0 ? '(' + objectiveService.empGroupLabels[objectiveService.empGroupLabels.length - objectiveService.selectedGroupItem.groupDTO.GroupLevel].GroupTypeName + ')' : objectiveService.selectedGroupItem.groupDTO.BaseGroupType == 1 ? '(' + objectiveService.recGroupLabels[objectiveService.recGroupLabels.length - objectiveService.selectedGroupItem.groupDTO.GroupLevel].GroupTypeName + ')' : ''}}</div>
        <div class="font-size-24" *ngIf="objectiveService.selectedAttributeItem != null">{{objectiveService.selectedAttributeItem.ValueName}}</div>
    </div>
</div>

<!-- Count Metrics -->
<div class="row mb-4" *ngIf="objectiveService.selectedGroupCards.quota.length > 0">
    <div class="col-12">
        <!-- if Quota (count metrics) has items -->
        <div class="d-flex clickable" (click)="showMetricType[0] = !showMetricType[0]">
            <svg class="icon-16 fill-theUpsideDown align-self-center">
                <use *ngIf="showMetricType[0]" href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use>
                <use *ngIf="!showMetricType[0]" href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use>
            </svg>
            <div class="color-theUpsideDown lato-bold mx-2" style="user-select:none" cvLocalizedText langSection="Objectives" langKey="Count_Metrics">Count Metrics</div>
            <div class="flex-grow-1 border-bottom" style="border-color:#d2d6db !important; margin-bottom:6px"></div>
        </div>

        <div class="mt-4" *ngIf="showMetricType[0]">
            <div class="card mt-3" *ngFor="let obj of objFilter(objectiveService.selectedGroupCards.quota, 0) | filterText: filterSelectedText" (click)="editObjectiveClick(obj)">
                <div class="hoverContainer pt-4 px-4" [ngClass]="{'pb-4': isLowestCard(obj) == obj.combinedObj.AssignedLevel}">
                    <button type="button" class="buttonHover icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute" style="top:16px; right:16px" hidden (click)="removeCard($event, obj)">
                        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
                    </button>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px">{{objectiveService.metricAbrDict[obj.MetricID].MetricName}}</div>
                        <div style="width:100px"></div>

                        <div class="justify-content-between" [ngClass]="{'flex-row-reverse': objectiveService.metricAbrDict[obj.MetricID].Direction == 1}" style="display:flex; width:496px"
                             *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, obj)">
                            <div style="flex:1" *ngFor="let color of pal.ObjectiveColors">{{color.ColorLabel}}</div>
                        </div>

                        <div class="d-flex justify-content-center" style="width:101px"></div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.emp.length == 0"><span cvLocalizedText langSection="Common" langKey="All">All</span> {{ "(Emp)"}}</div>
                        <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.emp.length > 0">{{obj.assignments.emp[0].GroupName}}{{' (' + objectiveService.empGroupLabels[objectiveService.empGroupLabels.length - obj.assignments.emp[0].GroupLevel].GroupTypeName + ')'}}</div>
                        <div style="width:100px" cvLocalizedText langSection="Objectives" langKey="Daily">Daily</div>

                        <div class="justify-content-between" style="display:flex; width:496px" *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, obj)">
                            <div style="flex:1" *ngFor="let item of [].constructor(pal.ObjectiveColors.length); let i = index">
                                <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : (pal.ObjectiveColors.length - i - 1))].HexColor}"
                                     *ngIf="obj.combinedObj.ObjectiveDetails[i] != null && obj.combinedObj.ObjectiveDetails[i].dayMinValue != null">
                                    {{obj.combinedObj.ObjectiveDetails[i].dayMinValue | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                </div>

                                <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i] == null || obj.combinedObj.ObjectiveDetails[i].dayMinValue == null"></div>

                                <div *ngIf="i == pal.ObjectiveColors.length - 1">
                                    <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : 0)].HexColor}"
                                         *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] != null && obj.combinedObj.ObjectiveDetails[i - 1].dayMinValue != null">
                                        {{0 | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                    </div>

                                    <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] == null || obj.combinedObj.ObjectiveDetails[i - 1].dayMinValue == null"></div>
                                </div>
                            </div>
                        </div>

                        <div class="position-relative text-center" style="width:37px; margin-right:64px; top:48px">{{obj.Alerts}}</div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.emp.length == 2">{{obj.assignments.emp[1].GroupName}}</div>

                        <div *ngIf="obj.assignments.emp.length > 2">
                            <div class="txtOverflow color-valyrianSteel" style="width:240px" *ngIf="obj.assignments.emp.length > 2" [ngbPopover]="empLstPopover1" placement="bottom" triggers="mouseenter:mouseleave">
                                {{'+ ' + (obj.assignments.emp.length - 1) + ' '}}<span cvLocalizedText langSection="Controls" langKey="More">More</span>
                            </div>

                            <ng-template #empLstPopover1>
                                <div class="FlexRowNoWrap" *ngFor="let item of obj.assignments.emp; let empidx = index" [hidden]="empidx == 0">
                                    <div *ngIf="empidx > 0">{{item.GroupName}}</div>
                                </div>
                            </ng-template>
                        </div>

                        <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.emp.length <= 1"></div>
                        <div style="width:100px" cvLocalizedText langSection="Objectives" langKey="Weekly">Weekly</div>

                        <div class="justify-content-between" style="display:flex; width:496px" *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, obj)">
                            <div style="flex:1" *ngFor="let item of [].constructor(pal.ObjectiveColors.length); let i = index">
                                <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : (pal.ObjectiveColors.length - i - 1))].HexColor}"
                                     *ngIf="obj.combinedObj.ObjectiveDetails[i] != null && obj.combinedObj.ObjectiveDetails[i].weekMinValue != null">
                                    {{obj.combinedObj.ObjectiveDetails[i].weekMinValue | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                </div>

                                <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i] == null || obj.combinedObj.ObjectiveDetails[i].weekMinValue == null"></div>

                                <div *ngIf="i == pal.ObjectiveColors.length - 1">
                                    <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : 0)].HexColor}"
                                         *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] != null && obj.combinedObj.ObjectiveDetails[i - 1].weekMinValue != null">
                                        {{0 | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                    </div>

                                    <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] == null || obj.combinedObj.ObjectiveDetails[i - 1].weekMinValue == null"></div>
                                </div>
                            </div>
                        </div>

                        <div class="position-relative text-center" style="width:37px; margin-right:64px; top:48px"></div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.rec.length == 0"><span cvLocalizedText langSection="Common" langKey="All">All</span>{{ "(Rec)"}}</div>
                        <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.rec.length > 0">{{obj.assignments.rec[0].GroupName}}{{' (' + objectiveService.recGroupLabels[objectiveService.recGroupLabels.length - obj.assignments.rec[0].GroupLevel].GroupTypeName + ')'}}</div>
                        <div style="width:100px" cvLocalizedText langSection="Objectives" langKey="Monthly">Monthly</div>

                        <div class="justify-content-between" style="display:flex; width:496px" *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, obj)">
                            <div style="flex:1" *ngFor="let item of [].constructor(pal.ObjectiveColors.length); let i = index">
                                <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : (pal.ObjectiveColors.length - i - 1))].HexColor}"
                                     *ngIf="obj.combinedObj.ObjectiveDetails[i] != null && obj.combinedObj.ObjectiveDetails[i].monthMinValue != null">
                                    {{obj.combinedObj.ObjectiveDetails[i].monthMinValue | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                </div>

                                <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i] == null || obj.combinedObj.ObjectiveDetails[i].monthMinValue == null"></div>

                                <div *ngIf="i == pal.ObjectiveColors.length - 1">
                                    <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : 0)].HexColor}"
                                         *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] != null && obj.combinedObj.ObjectiveDetails[i - 1].monthMinValue != null">
                                        {{0 | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                    </div>

                                    <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] == null || obj.combinedObj.ObjectiveDetails[i - 1].monthMinValue == null"></div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-center" style="width:101px"></div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.rec.length == 2">{{obj.assignments.rec[1].GroupName}}</div>

                        <div *ngIf="obj.assignments.rec.length > 2">
                            <div class="txtOverflow color-valyrianSteel" style="width:240px" *ngIf="obj.assignments.rec.length > 2" [ngbPopover]="recLstPopover1" placement="bottom" triggers="mouseenter:mouseleave">
                                {{'+ ' + (obj.assignments.rec.length - 1) + ' '}}<span cvLocalizedText langSection="Controls" langKey="More">More</span>
                            </div>

                            <ng-template #recLstPopover1>
                                <div class="d-flex" *ngFor="let item of obj.assignments.rec; let recidx = index" [hidden]="recidx == 0">
                                    <div *ngIf="recidx > 0">{{item.GroupName}}</div>
                                </div>
                            </ng-template>
                        </div>

                        <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.rec.length <= 1"></div>
                        <div style="width:100px"></div>
                        <div class="justify-content-between" style="display:flex; width:496px"></div>
                        <div style="width:37px; margin-right:64px"></div>
                        <div class="d-flex justify-content-center" style="width:101px"></div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.attr.length > 0">{{obj.assignments.attr[0].AttributeValueName}}</div>
                        <div style="width:240px" *ngIf="obj.assignments.attr.length == 0"></div>
                        <div style="width:100px"></div>
                        <div class="justify-content-between" style="display:flex; width:496px"></div>
                        <div style="width:37px; margin-right:64px"></div>
                        <div class="d-flex justify-content-center" style="width:101px"></div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.attr.length == 2">{{obj.assignments.attr[1].AttributeValueName}}</div>

                        <div *ngIf="obj.assignments.attr.length > 2">
                            <div class="txtOverflow color-valyrianSteel" style="width:240px" *ngIf="obj.assignments.attr.length > 2" [ngbPopover]="attrLstPopover1" placement="bottom" triggers="mouseenter:mouseleave">
                                {{'+ ' + (obj.assignments.attr.length - 1) + ' '}}<span cvLocalizedText langSection="Controls" langKey="More">More</span>
                            </div>

                            <ng-template #attrLstPopover1>
                                <div class="d-flex" *ngFor="let item of obj.assignments.attr; let attridx = index" [hidden]="attridx == 0">
                                    <div *ngIf="attridx > 0">{{item.AttributeValueName}}</div>
                                </div>
                            </ng-template>
                        </div>

                        <div style="width:240px" *ngIf="obj.assignments.attr.length <= 1"></div>
                        <div style="width:100px"></div>
                        <div class="justify-content-between" style="display:flex; width:496px"></div>
                        <div style="width:37px; margin-right:64px"></div>
                        <div class="d-flex justify-content-center" style="width:101px"></div>
                    </div>

                    <div class="mt-3 mx-3 border" *ngIf="isLowestCard(obj) != obj.combinedObj.AssignedLevel"></div>
                </div>

                <div class="hoverContainer pt-3 px-4 position-relative" [ngClass]="{'pb-4': isLowestCard(obj) == subObj.combinedObj.AssignedLevel}"
                     *ngFor="let subObj of objFilter(objectiveService.selectedGroupCards.quota, obj.combinedObj.ObjectiveID) | filterText: filterSelectedText">
                    <button type="button" class="buttonHover icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute" style="top:8px; right:16px" hidden (click)="removeCard($event, subObj)">
                        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
                    </button>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px"></div>
                        <div class="position-relative lato-bold" style="width:100px; top:-8px">{{objectiveService.empGroupLabels[objectiveService.empGroupLabels.length - subObj.combinedObj.AssignedLevel].GroupTypeName + 's'}}</div>

                        <div class="justify-content-between" [ngClass]="{'flex-row-reverse': objectiveService.metricAbrDict[obj.MetricID].Direction == 1}" style="display:flex; width:496px"
                             *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, subObj)">
                            <div style="flex:1" *ngFor="let color of pal.ObjectiveColors">{{color.ColorLabel}}</div>
                        </div>

                        <div class="d-flex justify-content-center" style="width:101px"></div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px"></div>
                        <div style="width:100px" cvLocalizedText langSection="Objectives" langKey="Daily">Daily</div>

                        <div class="justify-content-between" style="display:flex; width:496px" *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, subObj)">
                            <div style="flex:1" *ngFor="let item of [].constructor(pal.ObjectiveColors.length); let i = index">
                                <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : (pal.ObjectiveColors.length - i - 1))].HexColor}"
                                     *ngIf="subObj.combinedObj.ObjectiveDetails[i] != null && subObj.combinedObj.ObjectiveDetails[i].dayMinValue != null">
                                    {{subObj.combinedObj.ObjectiveDetails[i].dayMinValue | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                </div>

                                <div style="flex:1" *ngIf="subObj.combinedObj.ObjectiveDetails[i] == null || subObj.combinedObj.ObjectiveDetails[i].dayMinValue == null"></div>

                                <div *ngIf="i == pal.ObjectiveColors.length - 1">
                                    <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : 0)].HexColor}"
                                         *ngIf="subObj.combinedObj.ObjectiveDetails[i - 1] != null && subObj.combinedObj.ObjectiveDetails[i - 1].dayMinValue != null">
                                        {{0 | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                    </div>

                                    <div style="flex:1" *ngIf="subObj.combinedObj.ObjectiveDetails[i - 1] == null || subObj.combinedObj.ObjectiveDetails[i - 1].dayMinValue == null"></div>
                                </div>
                            </div>
                        </div>

                        <div class="position-relative text-center" style="width:37px; margin-right:64px; top:48px">{{obj.Alerts}}</div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px"></div>
                        <div style="width:100px" cvLocalizedText langSection="Objectives" langKey="Weekly">Weekly</div>

                        <div class="justify-content-between" style="display:flex; width:496px" *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, subObj)">
                            <div style="flex:1" *ngFor="let item of [].constructor(pal.ObjectiveColors.length); let i = index">
                                <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : (pal.ObjectiveColors.length - i - 1))].HexColor}"
                                     *ngIf="subObj.combinedObj.ObjectiveDetails[i] != null && subObj.combinedObj.ObjectiveDetails[i].weekMinValue != null">
                                    {{subObj.combinedObj.ObjectiveDetails[i].weekMinValue | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                </div>

                                <div style="flex:1" *ngIf="subObj.combinedObj.ObjectiveDetails[i] == null || subObj.combinedObj.ObjectiveDetails[i].weekMinValue == null"></div>

                                <div *ngIf="i == pal.ObjectiveColors.length - 1">
                                    <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : 0)].HexColor}"
                                         *ngIf="subObj.combinedObj.ObjectiveDetails[i - 1] != null && subObj.combinedObj.ObjectiveDetails[i - 1].weekMinValue != null">
                                        {{0 | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                    </div>

                                    <div style="flex:1" *ngIf="subObj.combinedObj.ObjectiveDetails[i - 1] == null || subObj.combinedObj.ObjectiveDetails[i - 1].weekMinValue == null"></div>
                                </div>
                            </div>
                        </div>

                        <div class="position-relative text-center" style="width:37px; margin-right:64px; top:48px"></div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="txtOverflow" style="width:240px"></div>
                        <div style="width:100px" cvLocalizedText langSection="Objectives" langKey="Monthly">Monthly</div>

                        <div class="justify-content-between" style="display:flex; width:496px" *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, subObj)">
                            <div style="flex:1" *ngFor="let item of [].constructor(pal.ObjectiveColors.length); let i = index">
                                <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : (pal.ObjectiveColors.length - i - 1))].HexColor}"
                                     *ngIf="subObj.combinedObj.ObjectiveDetails[i] != null && subObj.combinedObj.ObjectiveDetails[i].monthMinValue != null">
                                    {{subObj.combinedObj.ObjectiveDetails[i].monthMinValue | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                </div>

                                <div style="flex:1" *ngIf="subObj.combinedObj.ObjectiveDetails[i] == null || subObj.combinedObj.ObjectiveDetails[i].monthMinValue == null"></div>

                                <div *ngIf="i == pal.ObjectiveColors.length - 1">
                                    <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : 0)].HexColor}"
                                         *ngIf="subObj.combinedObj.ObjectiveDetails[i - 1] != null && subObj.combinedObj.ObjectiveDetails[i - 1].monthMinValue != null">
                                        {{0 | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                    </div>

                                    <div style="flex:1" *ngIf="subObj.combinedObj.ObjectiveDetails[i - 1] == null || subObj.combinedObj.ObjectiveDetails[i - 1].monthMinValue == null"></div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-center" style="width:101px"></div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div style="width:240px"></div>
                        <div style="width:100px"></div>
                        <div class="justify-content-between" style="display:flex; width:496px"></div>
                        <div style="width:37px; margin-right:64px"></div>
                        <div class="d-flex justify-content-center" style="width:101px"></div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div style="width:240px"></div>
                        <div style="width:100px"></div>
                        <div class="justify-content-between" style="display:flex; width:496px"></div>
                        <div style="width:37px; margin-right:64px"></div>
                        <div class="d-flex justify-content-center" style="width:101px"></div>
                    </div>

                    <div class="mt-3 mx-3 border" *ngIf="isLowestCard(obj) != subObj.combinedObj.AssignedLevel"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Normalized Metrics -->
<div class="row mb-4" *ngIf="objectiveService.selectedGroupCards.normalized.length > 0">
    <div class="col-12">
        <!-- if Normalized (count metrics) has items -->
        <div class="d-flex clickable" (click)="showMetricType[1] = !showMetricType[1]">
            <svg class="icon-16 fill-theUpsideDown align-self-center">
                <use *ngIf="showMetricType[1]" href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use>
                <use *ngIf="!showMetricType[1]" href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use>
            </svg>

            <div class="color-theUpsideDown lato-bold mx-2" style="user-select:none" cvLocalizedText langSection="Objectives" langKey="Normalized_Metrics">Normalized Metrics</div>
            <div class="flex-grow-1 border-bottom" style="border-color:#d2d6db !important; margin-bottom:6px"></div>
        </div>

        <div class="mt-4" *ngIf="showMetricType[1]">
            <div class="hoverContainer card p-4 mt-3" *ngFor="let obj of objectiveService.selectedGroupCards.normalized | filterText: filterSelectedText" (click)="editObjectiveClick(obj)">
                <div class="d-flex justify-content-between">
                    <div class="txtOverflow" style="width:240px">{{objectiveService.metricAbrDict[obj.MetricID].MetricName}}</div>

                    <div class="justify-content-between" [ngClass]="{'flex-row-reverse': objectiveService.metricAbrDict[obj.MetricID].Direction == 1}" style="display:flex; width:496px"
                         *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, obj)">
                        <div style="flex:1" *ngFor="let color of pal.ObjectiveColors">{{color.ColorLabel}}</div>
                    </div>

                    <div class="d-flex justify-content-center" style="width:101px">
                        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" *ngIf="isInheritedCard(obj) == false">
                            <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
                        </button>

                        <div *ngIf="isInheritedCard(obj) == true" cvLocalizedText langSection="Objectives" langKey="Inherited">Inherited</div>
                    </div>
                </div>

                <div class="d-flex justify-content-between">
                    <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.emp.length == 0"><span cvLocalizedText langSection="Common" langKey="All">All</span> {{ "(Emp)"}}</div>
                    <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.emp.length > 0">{{obj.assignments.emp[0].GroupName}}{{' (' + objectiveService.empGroupLabels[objectiveService.empGroupLabels.length - obj.assignments.emp[0].GroupLevel].GroupTypeName + ')'}}</div>

                    <div class="justify-content-between" style="display:flex; width:496px" *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, obj)">
                        <div style="flex:1" *ngFor="let item of [].constructor(pal.ObjectiveColors.length); let i = index">
                            <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : (pal.ObjectiveColors.length - i - 1))].HexColor}"
                                 *ngIf="obj.combinedObj.ObjectiveDetails[i] != null && obj.combinedObj.ObjectiveDetails[i].dayMinValue != null">
                                {{obj.combinedObj.ObjectiveDetails[i].dayMinValue | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                            </div>

                            <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i] == null || obj.combinedObj.ObjectiveDetails[i].dayMinValue == null"></div>

                            <div *ngIf="i == pal.ObjectiveColors.length - 1">
                                <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : 0)].HexColor}"
                                     *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] != null && obj.combinedObj.ObjectiveDetails[i - 1].dayMinValue != null">
                                    {{0 | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                </div>

                                <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] == null || obj.combinedObj.ObjectiveDetails[i - 1].dayMinValue == null"></div>
                            </div>
                        </div>
                    </div>

                    <div class="position-relative text-center" style="width:37px; margin-right:64px; top:48px">{{obj.Alerts}}</div>
                </div>

                <div class="d-flex justify-content-between">
                    <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.emp.length == 2">{{obj.assignments.emp[1].GroupName}}</div>

                    <div *ngIf="obj.assignments.emp.length > 2">
                        <div class="txtOverflow color-valyrianSteel" style="width:240px" *ngIf="obj.assignments.emp.length > 2" [ngbPopover]="empLstPopover2" placement="bottom" triggers="mouseenter:mouseleave">
                            {{'+ ' + (obj.assignments.emp.length - 1) + ' '}}<span cvLocalizedText langSection="Controls" langKey="More">More</span>
                        </div>

                        <ng-template #empLstPopover2>
                            <div class="d-flex" *ngFor="let item of obj.assignments.emp; let empidx = index" [hidden]="empidx == 0">
                                <div *ngIf="empidx > 0">{{item.GroupName}}</div>
                            </div>
                        </ng-template>
                    </div>

                    <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.emp.length <= 1"></div>

                    <div class="justify-content-between" style="display:flex; width:496px" *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, obj)">
                        <div style="flex:1" *ngFor="let item of [].constructor(pal.ObjectiveColors.length); let i = index">
                            <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : (pal.ObjectiveColors.length - i - 1))].HexColor}"
                                 *ngIf="obj.combinedObj.ObjectiveDetails[i] != null && obj.combinedObj.ObjectiveDetails[i].weekMinValue != null">
                                {{obj.combinedObj.ObjectiveDetails[i].weekMinValue | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                            </div>

                            <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i] == null || obj.combinedObj.ObjectiveDetails[i].weekMinValue == null"></div>

                            <div *ngIf="i == pal.ObjectiveColors.length - 1">
                                <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : 0)].HexColor}"
                                     *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] != null && obj.combinedObj.ObjectiveDetails[i - 1].weekMinValue != null">
                                    {{0 | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                </div>

                                <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] == null || obj.combinedObj.ObjectiveDetails[i - 1].weekMinValue == null"></div>
                            </div>
                        </div>
                    </div>

                    <div class="position-relative text-center" style="width:37px; margin-right:64px; top:48px"></div>
                </div>

                <div class="d-flex justify-content-between">
                    <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.rec.length == 0"><span cvLocalizedText langSection="Common" langKey="All">All</span>{{ "(Rec)"}}</div>
                    <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.rec.length > 0">{{obj.assignments.rec[0].GroupName}}{{' (' + objectiveService.recGroupLabels[objectiveService.recGroupLabels.length - obj.assignments.rec[0].GroupLevel].GroupTypeName + ')'}}</div>

                    <div class="justify-content-between" style="display:flex; width:496px" *ngFor="let pal of paletteFilter(objectiveService.colorPalettes, obj)">
                        <div style="flex:1" *ngFor="let item of [].constructor(pal.ObjectiveColors.length); let i = index">
                            <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : (pal.ObjectiveColors.length - i - 1))].HexColor}"
                                 *ngIf="obj.combinedObj.ObjectiveDetails[i] != null && obj.combinedObj.ObjectiveDetails[i].monthMinValue != null">
                                {{obj.combinedObj.ObjectiveDetails[i].monthMinValue | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                            </div>

                            <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i] == null || obj.combinedObj.ObjectiveDetails[i].monthMinValue == null"></div>

                            <div *ngIf="i == pal.ObjectiveColors.length - 1">
                                <div class="colorHover" [ngStyle]="{'color': pal.ObjectiveColors[(objectiveService.metricAbrDict[obj.MetricID].Direction == 0 ? i : 0)].HexColor}"
                                     *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] != null && obj.combinedObj.ObjectiveDetails[i - 1].monthMinValue != null">
                                    {{0 | objectiveTime:objectiveService.metricAbrDict[obj.MetricID].TimeType}}
                                </div>

                                <div style="flex:1" *ngIf="obj.combinedObj.ObjectiveDetails[i - 1] == null || obj.combinedObj.ObjectiveDetails[i - 1].monthMinValue == null"></div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center" style="width:101px"></div>
                </div>

                <div class="d-flex justify-content-between">
                    <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.rec.length == 2">{{obj.assignments.rec[1].GroupName}}</div>

                    <div *ngIf="obj.assignments.rec.length > 2">
                        <div class="txtOverflow color-valyrianSteel" style="width:240px" *ngIf="obj.assignments.rec.length > 2" [ngbPopover]="recLstPopover2" placement="bottom" triggers="mouseenter:mouseleave">
                            {{'+ ' + (obj.assignments.rec.length - 1) + ' '}}<span cvLocalizedText langSection="Controls" langKey="More">More</span>
                        </div>

                        <ng-template #recLstPopover2>
                            <div class="d-flex" *ngFor="let item of obj.assignments.rec; let recidx = index" [hidden]="recidx == 0">
                                <div *ngIf="recidx > 0">{{item.GroupName}}</div>
                            </div>
                        </ng-template>
                    </div>

                    <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.rec.length <= 1"></div>
                    <div class="justify-content-between" style="display:flex; width:496px"></div>
                    <div style="width:37px; margin-right:64px"></div>
                    <div class="d-flex justify-content-center" style="width:101px"></div>
                </div>

                <div class="d-flex justify-content-between">
                    <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.attr.length > 0">{{obj.assignments.attr[0].AttributeValueName}}</div>
                    <div style="width:240px" *ngIf="obj.assignments.attr.length == 0"></div>
                    <div class="justify-content-between" style="display:flex; width:496px"></div>
                    <div style="width:37px; margin-right:64px"></div>
                    <div class="d-flex justify-content-center" style="width:101px"></div>
                </div>

                <div class="d-flex justify-content-between">
                    <div class="txtOverflow" style="width:240px" *ngIf="obj.assignments.attr.length == 2">{{obj.assignments.attr[1].AttributeValueName}}</div>
                    <div *ngIf="obj.assignments.attr.length > 2">
                        <div class="txtOverflow color-valyrianSteel" style="width:240px" *ngIf="obj.assignments.attr.length > 2" [ngbPopover]="attrLstPopover2" placement="bottom" triggers="mouseenter:mouseleave">
                            {{'+ ' + (obj.assignments.attr.length - 1) + ' '}}<span cvLocalizedText langSection="Controls" langKey="More">More</span>
                        </div>

                        <ng-template #attrLstPopover2>
                            <div class="d-flex" *ngFor="let item of obj.assignments.attr; let attridx = index" [hidden]="attridx == 0">
                                <div *ngIf="attridx > 0">{{item.AttributeValueName}}</div>
                            </div>
                        </ng-template>
                    </div>

                    <div style="width:240px" *ngIf="obj.assignments.attr.length <= 1"></div>
                    <div class="justify-content-between" style="display:flex; width:496px"></div>
                    <div style="width:37px; margin-right:64px"></div>
                    <div class="d-flex justify-content-center" style="width:101px"></div>
                </div>
            </div>
        </div>
    </div>
</div>
